<template>
    <div
        class="relative"
        :style="{
            'font-family': wall.fontFamily,
            'background-color': wall.formColors?.background,
        }"
    >
        <div
            class="w-full max-w-[400px] mx-auto ct-bg-2--alt py-16 lg:py-32 px-5 lg:px-4"
            :style="{
                'background-color': wall.formColors?.background,
            }"
        >
            <div class="mx-auto w-full max-w-[400px] space-y-8">
                <cUtilsEdit @edit="goToRequestField('wallAskImg')">
                    <img v-if="wall.askImg" class="h-8 rounded-md" :src="wall.askImg" />
                </cUtilsEdit>

                <cUtilsEdit @edit="goToRequestField('wallAskTitle')">
                    <h2
                        :style="{
                            color: wall.formColors?.text,
                        }"
                        class="text-2xl font-medium ct-text-1"
                        v-html="wallAskTitle"
                    ></h2>
                </cUtilsEdit>

                <cUtilsEdit @edit="goToRequestField('wallAskDesc')">
                    <p
                        :style="{
                            color: wall.formColors?.text,
                        }"
                        class="text-base ct-text-2 opacity-80"
                        v-html="wallDesc"
                    ></p>
                </cUtilsEdit>

                <div class="space-y-2">
                    <p class="text-base ct-text-2 opacity-80">
                        {{ $t("r_love.review_mail.choose_rating") }}
                    </p>
                    <StarsMd :color="wall.starsColor" :rate="0" />
                </div>

                <cUtilsEdit @edit="goToRequestField('wallAuthor')">
                    <div class="flex items-center space-x-3">
                        <img
                            v-if="wall.author?.avatar"
                            :src="wall.author.avatar"
                            class="h-10 w-10 rounded-full object-cover"
                        />
                        <div
                            class="space-y-0.5"
                            :style="{
                                color: wall.formColors?.text,
                            }"
                        >
                            <p class="text-sm font-medium">{{ wall.author?.name }}</p>
                            <p class="opacity-80 text-xs">{{ wall.author?.position }}</p>
                        </div>
                    </div>
                </cUtilsEdit>
            </div>
        </div>
    </div>
</template>

<script>
import { richTextModel } from "@easy/ui/forms";
import { StarsMd } from "@easy/ui/stars";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";
import { useLoveGoTo } from "@/views/tools/love/utils/useLoveGoTo";

export default {
    name: "LoveMailBody",
    components: {
        StarsMd,
        cUtilsEdit,
    },
    setup() {
        const { goToRequestField } = useLoveGoTo();
        return { goToRequestField };
    },
    props: {
        wall: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        wallDesc() {
            // ? parseCode(escapeHtml(this.wall.askDesc), !isColorDark(this.wall.textColor))
            return this.wall.askDesc
                ? richTextModel.parseToHTMLFromMarkdown(this.wall.askDesc)
                : "";
        },
        wallAskTitle() {
            // ? parseCode(escapeHtml(this.wall.askTitle), !isColorDark(this.wall.textColor))
            return this.wall.askTitle
                ? richTextModel.parseToHTMLFromMarkdown(this.wall.askTitle)
                : "";
        },
    },
};
</script>
